import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Instagram, Facebook, Youtube, Music, Mic, Mail, Phone, MapPin, Send } from 'lucide-react';
import { motion } from 'framer-motion';
export function Contact() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-296">
      <Header data-id="element-297" />

      <main className="pt-32 pb-24" data-id="element-298">
        <section className="max-w-7xl mx-auto px-6 mb-24" data-id="element-299">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-300">
            {/* Contact Info & Social */}
            <div className="lg:col-span-5" data-id="element-301">
              <span className="section-overline" data-id="element-302">Get in Touch</span>
              <h1 className="text-[#4A0E0E] mb-8" data-id="element-303">
                Let's Create Something Extraordinary
              </h1>
              <p className="text-[#2C2C2C]/60 mb-12" data-id="element-304">
                Whether you're planning an intimate home tasting or a
                large-scale corporate gala, our team is ready to curate a
                bespoke experience tailored to your vision.
              </p>

              <div className="space-y-8 mb-16" data-id="element-305">
                <div className="flex items-center gap-6 group" data-id="element-306">
                  <div className="w-12 h-12 rounded-full bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-307">
                    <Mail size={20} data-id="element-308" />
                  </div>
                  <div data-id="element-309">
                    <p className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 mb-1" data-id="element-310">
                      Email Us
                    </p>
                    <p className="font-serif text-[#4A0E0E]" data-id="element-311">
                      hello@corkdorx.com
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-6 group" data-id="element-312">
                  <div className="w-12 h-12 rounded-full bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-313">
                    <Phone size={20} data-id="element-314" />
                  </div>
                  <div data-id="element-315">
                    <p className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 mb-1" data-id="element-316">
                      Call Us
                    </p>
                    <p className="font-serif text-[#4A0E0E]" data-id="element-317">(951) 555-0123</p>
                  </div>
                </div>
                <div className="flex items-center gap-6 group" data-id="element-318">
                  <div className="w-12 h-12 rounded-full bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-319">
                    <MapPin size={20} data-id="element-320" />
                  </div>
                  <div data-id="element-321">
                    <p className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 mb-1" data-id="element-322">
                      Location
                    </p>
                    <p className="font-serif text-[#4A0E0E]" data-id="element-323">
                      Temecula, CA & Beyond
                    </p>
                  </div>
                </div>
              </div>

              {/* Social Media Section */}
              <div className="pt-12 border-t border-[#E6D5B8]/30" data-id="element-324">
                <h4 className="text-xs font-bold uppercase tracking-[0.2em] mb-8" data-id="element-325">
                  Connect With Us
                </h4>
                <div className="grid grid-cols-3 gap-6" data-id="element-326">
                  <a href="#" className="flex flex-col items-center gap-3 group" data-id="element-327">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-328">
                      <Instagram size={24} data-id="element-329" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 group-hover:text-[#4A0E0E]" data-id="element-330">
                      Instagram
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group" data-id="element-331">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-332">
                      <Facebook size={24} data-id="element-333" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 group-hover:text-[#4A0E0E]" data-id="element-334">
                      Facebook
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group opacity-40 hover:opacity-100 transition-opacity" data-id="element-335">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E]" data-id="element-336">
                      <Music size={24} data-id="element-337" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40" data-id="element-338">
                      TikTok
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group opacity-40 hover:opacity-100 transition-opacity" data-id="element-339">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E]" data-id="element-340">
                      <Youtube size={24} data-id="element-341" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40" data-id="element-342">
                      YouTube
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group opacity-40 hover:opacity-100 transition-opacity" data-id="element-343">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E]" data-id="element-344">
                      <Mic size={24} data-id="element-345" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40" data-id="element-346">
                      Podcast
                    </span>
                  </a>
                </div>
              </div>
            </div>

            {/* Inquiry Form */}
            <div className="lg:col-span-7" data-id="element-347">
              <div className="bg-[#FDFCF0] p-8 md:p-16 rounded-[3rem] border border-[#E6D5B8]/50 shadow-sm" data-id="element-348">
                <h2 className="text-3xl font-serif text-[#4A0E0E] mb-12" data-id="element-349">
                  Inquiry Form
                </h2>
                <form className="space-y-8" data-id="element-350">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-351">
                    <div className="space-y-2" data-id="element-352">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-353">
                        Full Name
                      </label>
                      <input type="text" placeholder="John Doe" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-354" />
                    </div>
                    <div className="space-y-2" data-id="element-355">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-356">
                        Email Address
                      </label>
                      <input type="email" placeholder="john@example.com" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-357" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-358">
                    <div className="space-y-2" data-id="element-359">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-360">
                        Phone Number
                      </label>
                      <input type="tel" placeholder="(555) 000-0000" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-361" />
                    </div>
                    <div className="space-y-2" data-id="element-362">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-363">
                        Desired Date
                      </label>
                      <input type="date" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-364" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-365">
                    <div className="space-y-2" data-id="element-366">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-367">
                        Event Type
                      </label>
                      <select className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-368">
                        <option data-id="element-369">Private Tasting</option>
                        <option data-id="element-370">Corporate Event</option>
                        <option data-id="element-371">Wine Cocktail Class</option>
                        <option data-id="element-372">Culinary Pairing</option>
                        <option data-id="element-373">Other</option>
                      </select>
                    </div>
                    <div className="space-y-2" data-id="element-374">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-375">
                        Guest Count
                      </label>
                      <input type="number" placeholder="e.g. 15" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-376" />
                    </div>
                  </div>

                  {/* Qualification Questions */}
                  <div className="pt-8 border-t border-[#E6D5B8]/30 space-y-8" data-id="element-377">
                    <h3 className="text-xl font-serif text-[#4A0E0E]" data-id="element-378">
                      Event Qualification
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-379">
                      <div className="space-y-4" data-id="element-380">
                        <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-381">
                          Event Category
                        </p>
                        <div className="flex gap-4" data-id="element-382">
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-383">
                            <input type="radio" name="category" className="accent-[#4A0E0E]" data-id="element-384" />
                            <span className="text-sm" data-id="element-385">Private</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-386">
                            <input type="radio" name="category" className="accent-[#4A0E0E]" data-id="element-387" />
                            <span className="text-sm" data-id="element-388">Corporate</span>
                          </label>
                        </div>
                      </div>
                      <div className="space-y-4" data-id="element-389">
                        <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-390">
                          Venue Status
                        </p>
                        <div className="flex gap-4" data-id="element-391">
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-392">
                            <input type="radio" name="venue" className="accent-[#4A0E0E]" data-id="element-393" />
                            <span className="text-sm" data-id="element-394">Secured</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-395">
                            <input type="radio" name="venue" className="accent-[#4A0E0E]" data-id="element-396" />
                            <span className="text-sm" data-id="element-397">Needed</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-398">
                      <div className="space-y-4" data-id="element-399">
                        <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-400">
                          Setting
                        </p>
                        <div className="flex gap-4" data-id="element-401">
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-402">
                            <input type="radio" name="setting" className="accent-[#4A0E0E]" data-id="element-403" />
                            <span className="text-sm" data-id="element-404">Indoor</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-405">
                            <input type="radio" name="setting" className="accent-[#4A0E0E]" data-id="element-406" />
                            <span className="text-sm" data-id="element-407">Outdoor</span>
                          </label>
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-408">
                        <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-409">
                          Estimated Budget
                        </label>
                        <select className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-410">
                          <option data-id="element-411">Under $2,500</option>
                          <option data-id="element-412">$2,500 - $5,000</option>
                          <option data-id="element-413">$5,000 - $10,000</option>
                          <option data-id="element-414">$10,000+</option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-4" data-id="element-415">
                      <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-416">
                        Wine Pairing Needed?
                      </p>
                      <div className="flex gap-4" data-id="element-417">
                        <label className="flex items-center gap-2 cursor-pointer" data-id="element-418">
                          <input type="radio" name="pairing" className="accent-[#4A0E0E]" data-id="element-419" />
                          <span className="text-sm" data-id="element-420">Yes</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer" data-id="element-421">
                          <input type="radio" name="pairing" className="accent-[#4A0E0E]" data-id="element-422" />
                          <span className="text-sm" data-id="element-423">No</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-424">
                    <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-425">
                      Additional Details
                    </label>
                    <textarea rows={4} placeholder="Tell us more about your vision..." className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none resize-none" data-id="element-426"></textarea>
                  </div>

                  <button className="w-full bg-[#4A0E0E] text-white py-6 rounded-full font-bold uppercase tracking-[0.2em] text-sm hover:bg-[#D4AF37] transition-all duration-500 shadow-xl flex items-center justify-center gap-3" data-id="element-427">
                    Submit Inquiry <Send size={18} data-id="element-428" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-429" />
    </motion.div>;
}